ui-cms-grid-element {
  display: block;
  grid-column: span 12;
  max-width: 100%;

  @include breakpoint($medium) {
    grid-column: auto / span var(--grid-element-span, 12);
  }

  > *:not(ui-cms-anchor) {
    margin-top: $sd-spacing-8;
  }

  > *:first-child,
  > ui-cms-anchor ~ :nth-child(2) {
    margin-top: 0;
  }

  &[centered] {
    @include breakpoint($medium) {
      grid-column: var(--start-column, 0) / span var(--grid-element-span, 12);
    }
  }
}

ui-cms-grid-element[reduced-spacing] {
  margin-bottom: calc(var(--grid-row-gap-reduction, 60) * -1px);
}
